import React from 'react'
import { Route, Routes } from "react-router-dom";
import {
    DetailsPayment,
    PersonalInformation,
    ConfirmPurchase,
    PurchaseDetail,
  } from "../View";
  
export const RouterPayment = () => {

    return (
        <Routes>
            <Route path="/details-payment" element={<DetailsPayment />} />
            <Route path="/personal-information" element={<PersonalInformation />} />
            <Route path="/confirm-purchase" element={<ConfirmPurchase />} />
            <Route path="/purchase-detail" element={<PurchaseDetail />} />
        </Routes>
    )
}
